'use client'
import React from 'react'
import styles from './styles.module.scss'
import { Status } from './types'

interface StatusTextProps {
  children: React.ReactNode
  status?: Status
  textAlign?: 'flex-start' | 'center' | 'flex-end'
}
const StatusText: React.FC<StatusTextProps> = ({
  children,
  status,
  textAlign = 'center',
}) => {
  return (
    <span
      className={`${styles.span} ${status ? styles[status] : ''}`}
      style={{ justifyContent: textAlign }}
    >
      {children}
    </span>
  )
}

export default StatusText
